require('./bootstrap');

window.Vue = require('vue');
import Vuex from 'vuex';

//Vue Select
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
// Set the components prop default to return our fresh components
Vue.component('v-select', vSelect);

//Calendar
import VCalendar from 'v-calendar';
Vue.use(VCalendar, {
    componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
    datePicker:{popover:{visibility:'focus'}},
});

import flatpickr from "flatpickr";
import { Portugues } from "flatpickr/dist/l10n/pt.js";
flatpickr.localize(Portugues);
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
Vue.component('v-datetimepicker', flatPickr);

//Mask
import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import moment from 'moment-timezone'; //Formatos : https://momentjs.com/docs/#/displaying/format/
require('moment/locale/pt-br');
Vue.use(require('vue-moment'), {moment});
moment.tz.setDefault("America/Sao_Paulo");

//Mask Money
import money from 'v-money'
Vue.use(money, {precision: 2});

//Vue-noty
import VueNoty from 'vuejs-noty';
import 'vuejs-noty/dist/vuejs-noty.css';
Vue.use(VueNoty,{layout: 'bottomRight', theme: 'bootstrap-v4', progressBar: true, timeout:2000});

//Tiny Editor de Texto
import Editor from '@tinymce/tinymce-vue'

//Vuex
const store = new Vuex.Store({
    state:{
        alerta:{},
        anexo:{},
        contrato:{},
        cliente:{},
        config:{},
        form:{},
        function:{},
        nav:false,
        notas:{},
        lista:{},
        modal:{},
        obra:{},
        ordem:{},
        paginate:{},
        processo:{},
        pncp:{},
        fornecedor:{},
        request:{},
        relatorio:{},
        subnav:false,
        subtab:false,
        tab:false,
        unidade:{},
        waiting_request:false,
    },
    mutations:{
        setProcesso(state,obj){state.processo = obj;},
    }
});

//COMPONENTES (A - Z)
Vue.component('anexos', require('./components/plugins/Anexos').default);
Vue.component('busca-3', require('./components/recursos/Busca-3').default);
Vue.component('chart-donut', require('./components/charts/Chart-Donut').default);
Vue.component('chart-line', require('./components/charts/Chart-Line').default);
Vue.component('chart-bar', require('./components/charts/Chart-Bar').default);
Vue.component('dropdown', require('./components/recursos/Dropdown').default);
Vue.component('endereco-2', require('./components/recursos/Endereco-2').default);
Vue.component('form-export', require('./components/formularios/FormExport').default);
Vue.component('form-steps', require('./components/formularios/FormSteps').default);
Vue.component('gerenciador-request', require('./components/recursos/GerenciadorRequests').default);
Vue.component('loading', require('./components/plugins/Loading').default);
Vue.component('modal-3', require('./components/modal/Modal-3').default);
Vue.component('paginate', require('./components/tabelas/Paginate').default);
Vue.component('password-confirm', require('./components/recursos/PasswordConfirm').default);
Vue.component('request', require('./components/recursos/Request').default);
Vue.component('tabela-6', require('./components/tabelas/Tabela-6').default);
Vue.component('upload-files', require('./components/plugins/Upload-files').default);

//busEvent
export const bus = new Vue();
//Loaders
import { HollowDotsSpinner } from 'epic-spinners';

import _ from 'lodash';

const app = new Vue({
    el: '#app',
    store,
    data: function () {
        return {
            flash:null,
            form:null,
            action:{},
            files:null,
            grupo:null,
            grafico:null,
            nav:null,
            render:true,
            relatorio:{},
            subnav:null,
            subtab:null,
            tab:null,
            _buscar:null,
        }
    },
    components: {
        HollowDotsSpinner,
        editor:Editor
    },
    methods:{
        gerenciadorRequest: (obj) => {
            bus.$emit('gerencia-request',obj);
        },
        busEmit: (emit,timeout = 0,event = null) => {
            setTimeout(() => {if(typeof emit === 'string'){bus.$emit(emit,event);}else if(typeof emit === 'object'){bus.$emit(emit.emit,emit.obj)}},timeout);
        },
        addObjectToState(state,obj){
            let st = {};
            for(var key in this.$store.state[state]){
                st[key] = this.$store.state[state][key];
            }
            for (var keyObj in obj){
                st[keyObj] = obj[keyObj];
            }
            this.$store.state[state] = st;
        },
        focusId(id_elemento,timeout = 200){
            setTimeout(function(){
                if(typeof id_elemento === 'string'){
                    if(document.getElementById(id_elemento)){
                        document.getElementById(id_elemento).focus()
                    }
                }else{
                    for(let id in id_elemento){
                        if(document.getElementById(id_elemento[id])){
                            document.getElementById(id_elemento[id]).focus();
                            break;
                        }
                    }
                }
            },timeout);
        },
        getElementById(id_elemento){
            return document.getElementById(id_elemento);
        },
        click(id_elemento,timeout = 200){
            setTimeout(function(){
                if(document.getElementById(id_elemento)){
                    document.getElementById(id_elemento).click()
                }
            },timeout);
        },
        redirect(obj){
            this.$noty.info('Redirecionando...',{layout: 'bottomCenter', timeout:2000});
            if(typeof obj === 'string'){window.location.href = obj;}
            else{//Verificando a opção de montar URL
                if(obj.montar_url){
                    obj.url = '';
                    for(let part in obj.montar_url){
                        if(obj.montar_url[part].valor){obj.url+= obj.montar_url[part].valor;}
                        else if(obj.montar_url[part].state){obj.url+= this.$store.state[obj.montar_url[part].state][obj.montar_url[part].chave];}
                    }
                }
                window.location.href = obj.url;
            }
        },
        limitText(string,limit){
            if(string && string.length >= limit){
                return string.substring(0,limit) + '...';
            }else{
                return string;
            }
        },
        onSearchVueSelect(search, loading,request,lista_key) {
            if(search.length > 0) {
                loading(true);
                this.search(search,loading,request,lista_key, this);
            }
        },
        search: _.debounce((search,loading,request,lista_key, vm) => {
            // vm.$options.data = {nome:'Testando',id_unidade:1};
            axios({
                url: request.url,
                method: 'POST',
                data: request.data
            })
                .then(res => {
                    var obj = {};
                    obj[lista_key] = res.data;
                    vm.addObjectToState('lista', obj);
                });

            loading(false);
        }, 1500),
        featherIcons(){setTimeout(function (){feather.replace();},200)},
        inputRequired(){
            setTimeout(function (){
                var el = $("label.required ~ div,label.required ~ span, label ~ input:required, label ~ select:required, label ~ textarea:required").parent().find('label').not('.required_input');
                el.addClass('required_input');
                el.append('<span class=\'text-danger\' title=\'Campo obrigatório\'>&nbsp;*</span>');
            },500);
        },
        exportar(obj){bus.$emit('form-export',obj);},
        confirmAlert(obj){bus.$emit('confirm-alert',obj);},
        noty(obj){
            if(obj.noty === 'warning'){
                this.$noty.warning(obj.content,{layout:'center', timeout:2000});
            }
        },
        baixar(obj){bus.$emit('form-download',obj);},
        downloadPDF(obj){bus.$emit('download-pdf',obj);},
        renderChart(obj){bus.$emit('render-chart',obj);},
        in_array(search,array){
            var c = 0;
            for (var n in array){
                if(array[n] === search){c++;}
            }
            return c > 0;
        },
        round(value, decimals) {
            return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
        },
        iconeAnexo(format){
            switch (format) {
                case 'jpg':
                case 'JPG':
                case 'jpeg':
                case 'JPEG':
                case 'bmp':
                case 'png':
                case 'PNG':
                    return "<i class='far fa-file-image' style='color: #3498db'></i>";
                case 'doc':
                case 'docx':
                    return "<i class='far fa-file-word text-primary'></i>";
                case 'txt':
                    return "<i class='far fa-file-alt'></i>";
                case 'pdf':
                    return "<i class='far fa-file-pdf text-danger'></i>";
                case 'xls':
                case 'xlsx':
                    return "<i class='fas fa-file-excel text-success'></i>";
                case 'xml':
                    return "<i class='far fa-file-code'></i>";
                case 'zip':
                case 'rar':
                    return "<i class='far fa-file-archive text-muted'></i>";
                default:
                    return "<i class='far fa-file'></i>";
            }
        },
    },
    filters:{
        numberFormat:function (valor,digitos_fracao = null) {
            var options = {};
            if(digitos_fracao){
                options.minimumFractionDigits = digitos_fracao;
                options.maximumFractionDigits = digitos_fracao;
            }
            return new Intl.NumberFormat('pt-BR',options).format(valor);
        },
        dateView(date){
            var parts = date.match(/(\d+)/g);
            var data_view = new Date(parts[0], parts[1]-1, parts[2]);
            let ye = new Intl.DateTimeFormat('pt-BR', { year: 'numeric' }).format(data_view);
            let mo = new Intl.DateTimeFormat('pt-BR', { month: '2-digit' }).format(data_view);
            let da = new Intl.DateTimeFormat('pt-BR', { day: '2-digit' }).format(data_view);
            return `${da}/${mo}/${ye}`;
        },
        cnpj(cnpj){
            //43.210.987/6543-21
            var n1 = cnpj.slice(0, -12);
            var n2 = cnpj.slice(-12, -9);
            var n3 = cnpj.slice(-9, -6);
            var n4 = cnpj.slice(-6, -2);
            var n5 = cnpj.slice(-2);
            return n1 + '.' + n2 + '.' + n3 + '/' + n4 + '-' + n5;
        },
        cpf(cnpj){
            //111.111.111-21
            var n1 = cnpj.slice(0, -8);
            var n2 = cnpj.slice(-8, -5);
            var n3 = cnpj.slice(-5, -2);
            var n4 = cnpj.slice(-2);
            return n1 + '.' + n2 + '.' + n3 + '-' + n4;
        }
    },
    created() {
        bus.$on('download-file', (obj) => {
            this.baixar(obj);
        });
    },
    mounted() {
        document.getElementById('app').style.display = 'block';

        $(document).on('focusin', function(e) {
            if ($(e.target).closest(".tox-dialog").length) {
                e.stopImmediatePropagation();
            }
        });

        $(".hover-collapse-head").hover(
            function() {
                console.log('hover');
                $('.hover-collapse').collapse('show');
            }, function() {
                $('.hover-collapse').collapse('hide');
            }
        );
    }
});
